import Localization, { TrustedValue } from 'lib/localization';
export default {
  tab: {
    title() {
      return Localization.get('bumblesite@privacy.informationSharing.tab.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.informationSharing.tab.description');
    },
    contents: {
      title() {
        return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.title');
      },
      item1() {
        return Localization.get('bumblesite@privacy.informationSharing.tab.contents.item1');
      },
    },
  },
  subsection1: {
    title() {
      return Localization.get('bumblesite@privacy.informationSharing.subsection1.title');
    },
    column1() {
      return Localization.get('bumblesite@privacy.informationSharing.subsection1.column1', {
        __EOL__: new TrustedValue('<br /><br />'),
      });
    },
    whatIsAggregating: {
      title() {
        return Localization.get(
          'bumblesite@privacy.informationSharing.subsection1.aggregating.title',
        );
      },
      content() {
        return Localization.get(
          'bumblesite@privacy.informationSharing.subsection1.aggregating.content',
        );
      },
    },
    goodToKnow: {
      title() {
        return Localization.get('bumblesite@privacy.goodToKnow');
      },
      content() {
        return Localization.get('bumblesite@privacy.informationSharing.subsection1.tip.content');
      },
    },
  },
  subsection2: {
    table() {
      return [
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.header1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.header2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row0.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row0.cell2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row1.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row1.cell2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row2.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row2.cell2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row3.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row3.cell2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row4.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row4.cell2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row4.1.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row4.1.cell2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row5.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row5.cell2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row6.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row6.cell2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row7.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row7.cell2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row8.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row8.cell2'),
        ],
        [
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row9.cell1'),
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row9.cell2'),
        ],
      ];
    },
  },
};
